import * as React from 'react';

import InlineVideo from 'components/InlineVideo';
import useLiveData from 'hooks/useLiveData';
import { useStaticQuery, graphql } from 'gatsby';

const InlineVideoProvider = (props) => {
	const data = useStaticQuery(graphql`
		query inlineVideos {
		  allSmartTagsInlineVideo {
			edges {
			  node {
				id
				thumbnail
				videoLoop
				videoEmbed
				video
			  }
			}
		  }
		}
	`);
	const {response} = useLiveData({
		namespace: 'SmartTags',
		model: 'InlineVideo',
		method: 'all',
		staticData: data,
		graphqlKey: 'allSmartTagsInlineVideo',
	});
	if (response.data.length === 0)return null;
	let attr;
	for (let item of response.data) {
		if (item.id === props.id)attr = item;
	}
	if (!attr)return null;
	return <InlineVideo {...attr} />
}

export default InlineVideoProvider;